module.exports = __webpack_public_path__ + "img/826.cfe309f2.png";